export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-smooth/node_modules/react-transition-group/esm/config.js
// module id = 1292
// module chunks = 0